import { toast } from "react-toastify";
import { scrollToField } from "../../utils/scrollToError";

const toastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const DEFAULT_TITLES = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Info",
};

const ToastContent = ({ title, message }) => (
  <div className="toast-content">
    <div className="toast-title">{title}</div>
    {message ? <div className="toast-message">{message}</div> : null}
  </div>
);

/**
 * showToast(content, type, duration, options)
 * content: a plain string (shown as the description, title defaults per type)
 *          or { title, message } to show both a title and a description.
 * options.field: for validation toasts — the field the message is about
 *          (data-field / id / name, a selector or an element). The page
 *          scrolls to it and focuses it.
 */
export const showToast = (
  content,
  type = "info",
  duration = 3000,
  options = {},
) => {
  if (options?.field) {
    // Wait a tick so a field rendered by the same state update exists.
    setTimeout(() => scrollToField(options.field), 50);
  }

  const config = { ...toastOptions, autoClose: duration };
  const defaultTitle = DEFAULT_TITLES[type] || DEFAULT_TITLES.info;

  let title;
  let message;
  if (content && typeof content === "object") {
    title = content.title?.trim() || defaultTitle;
    message = content.message?.trim() || "";
  } else {
    title = defaultTitle;
    message =
      typeof content === "string" && content.trim()
        ? content
        : "Something went wrong. Please try again.";
  }

  const body = <ToastContent title={title} message={message} />;

  switch (type) {
    case "success":
      toast.success(body, config);
      break;
    case "error":
      toast.error(body, config);
      break;
    case "warning":
      toast.warning(body, config);
      break;
    default:
      toast.info(body, config);
  }
};
